module.exports = __webpack_public_path__ + "img/up_icon.5abd90e6.png";